import React, { useState } from "react";
import { Button } from "reactstrap";
import { useCookieConsent } from "./CookieConsentProvider";
import CookieSettingsModal from "./CookieSettingsModal";

export default function CookieBanner() {
  const { consent, acceptAll, rejectAll } = useCookieConsent();
  const [settingsOpen, setSettingsOpen] = useState(false);

  // kullanıcı bir seçim yapmışsa banner görünmesin
  if (consent.thirdPartyMedia !== null) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          left: 16,
          right: 16,
          bottom: 16,
          zIndex: 9999,
          maxWidth: 1100,
          margin: "0 auto",
          borderRadius: 16,
          background: "rgba(15, 23, 42, 0.96)",
          color: "white",
          padding: "14px 16px",
          boxShadow: "0 16px 32px rgba(0,0,0,0.28)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div style={{ minWidth: 260, flex: 1 }}>
            <div style={{ fontWeight: 800, marginBottom: 4 }}>
              Çerez Tercihleri
            </div>
            <div style={{ opacity: 0.85, fontSize: 13, lineHeight: 1.5 }}>
              Web sitemizin güvenli şekilde çalışması ve hizmet kalitesinin
              artırılması amacıyla çerezler kullanılmaktadır. Tercihlerinizi
              “Ayarlar” üzerinden yönetebilir, detaylı bilgiye{" "}
              <a
                href="/cerez-politikasi"
                style={{ color: "white", textDecoration: "underline" }}
              >
                Çerez Politikası
              </a>{" "}
              sayfasından ulaşabilirsiniz.
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "flex-end",
              width: "100%",
              flex: "0 0 auto",
            }}
            className="cookie-actions"
          >
            <span
              role="button"
              tabIndex={0}
              onClick={() => setSettingsOpen(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") setSettingsOpen(true);
              }}
              style={{
                color: "white",
                textDecoration: "underline",
                textUnderlineOffset: 3,
                cursor: "pointer",
                fontWeight: 700,
                padding: "8px 10px",
                borderRadius: 999,
                opacity: 0.95,
              }}
            >
              Ayarlar
            </span>

            <Button
              color="info"
              className="btn-raised btn-round cookie-btn"
              onClick={rejectAll}
              style={{ whiteSpace: "nowrap" }}
            >
              Tümünü Reddet
            </Button>

            <Button
              color="info"
              className="btn-raised btn-round cookie-btn"
              onClick={acceptAll}
              style={{ whiteSpace: "nowrap" }}
            >
              Tümünü Kabul Et
            </Button>

            {/* sadece mobil/dar ekran için: butonlar full width */}
            <style>{`
              @media (max-width: 576px) {
                .cookie-actions {
                  justify-content: flex-start !important;
                }
                .cookie-btn {
                  width: 100% !important;
                }
              }
              @media (min-width: 577px) {
                .cookie-actions {
                  width: auto !important;
                }
              }
            `}</style>
          </div>
        </div>
      </div>

      <CookieSettingsModal
        isOpen={settingsOpen}
        toggle={() => setSettingsOpen((v) => !v)}
      />
    </>
  );
}
